module.exports = __webpack_public_path__ + "media/images/eyecatch-shortcut-profile-058f6c5b4b79b32bd33b12208f3d8de6.jpg";